import React from "react";
import { Modal, ListGroup } from "react-bootstrap";
import styles from "./styles.module.scss";
import { track } from "utils/amplitude";

const AMPLITUDE_COMPONENT_NAME = "phone-session-type-selection-modal";

const PhoneSessionTypeModal = ({
  show,
  onHide,
  setSelectedType,
  appointmentTypes,
  setShowSessionsModal,
  amplitudePageName,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName={styles["session-type-with-backdrop__modal-dialog"]}
      contentClassName={styles["session-type-with-backdrop__modal-content"]}
      className={styles["session-type-with-backdrop__modal"]}
    >
      <ListGroup>
        <ListGroup.Item className="gray01">Session types</ListGroup.Item>
        {appointmentTypes
          .filter((type) => !type.invite_only)
          .map((type, index) => {
            return (
              <ListGroup.Item
                className="justify-content-between d-inline-flex border-0"
                key={index}
                onClick={() => {
                  track(
                    amplitudePageName,
                    [AMPLITUDE_COMPONENT_NAME, "session-type-selector"],
                    "click",
                  );
                  setSelectedType(type);
                  setShowSessionsModal(true);
                }}
              >
                {type.label}{" "}
                <div className="gray01">{`$${type.price}/${type.length_min}min`}</div>
              </ListGroup.Item>
            );
          })}
      </ListGroup>
    </Modal>
  );
};

export default PhoneSessionTypeModal;
